import React, { Component }  from 'react';

import "./right.scss";

export default function Right() {
  return (
    <div className="right">
        <img src="images/right-image-new.png" alt="Image" className="image image-mobile"/>
    </div>
  )
}
